<div class="main">
    <div class="section">
      <div class="header">
        <span *ngIf="!parentData.element">{{'HOLIDAYS_LIST.title' | translate}}</span>
        <span *ngIf="parentData.element">{{'HOLIDAYS_LIST.edit_holiday' | translate}}</span>
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </div>
      <div class="container">
        <div class="content">
          <div class="inputSection">
            <div class="label">
              {{'unit.year_calendar' | translate}}<sup style="color: #E54131;">*</sup>
            </div>
            <input type="text" [(ngModel)]="holiday_date.date" (click)="acc_deadline.open()" [matDatepicker]="acc_deadline"/>
            <mat-datepicker #acc_deadline  (closed)="setHolidayDate(holiday_date)" ></mat-datepicker>
            <i class="material-icons pull-right add-icon calendar">date_range</i>
          </div>
          <div class="inputSection">
            <div class="label" style="margin-bottom:6px">
              {{'unit.description' | translate}}<sup style="color: #E54131;">*</sup>
            </div>
            <input type="text"  [(ngModel)]="holiday_description">
          </div>
          <div class="submitButton">
            <div class="button" (click)="updateHoliday();">
              <span *ngIf="!parentData.element">{{'HOLIDAYS_LIST.submit' | translate}}</span>
              <span *ngIf="parentData.element">{{'HOLIDAYS_LIST.update' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  